import { derived } from 'svelte/store';
import { financementsStore } from './financements.store';
import { rechercheParRegion } from './rechercheParRegion.store';
import { rechercheParTypeFinancement } from './rechercheParTypeFinancement.store';
import { rechercheParTypeOrganisation } from './rechercheParTypeOrganisation.store';

export const financementsFiltre = derived(
  [financementsStore, rechercheParRegion, rechercheParTypeFinancement, rechercheParTypeOrganisation],
  ([$financementsStore, $rechercheParRegion, $rechercheParTypeFinancement, $rechercheParTypeOrganisation]) => {
    const resultat = $financementsStore.filter(
      (f) => rechercheParRegion.ok(f) && rechercheParTypeFinancement.ok(f) && rechercheParTypeOrganisation.ok(f)
    );

    const typesFinancement = [...new Set($financementsStore.map((t) => t.typesDeFinancement).flat())].sort((a, b) => {
      if (a === "Aide à l'innovation cyber") return 1;
      return a.localeCompare(b);
    });

    const typesOrganisation = [...new Set($financementsStore.map((t) => t.entitesElligibles).flat())].sort((a, b) => {
      if (a === 'Toutes entités publiques') return 1;
      return b.localeCompare(a);
    });

    const filtreActif =
      $rechercheParRegion.length !== 0 ||
      $rechercheParTypeFinancement.length !== 0 ||
      $rechercheParTypeOrganisation.length !== 0;

    return { resultat, typesFinancement, typesOrganisation, filtreActif };
  }
);
